import { render } from "./UiPropJsonSchema.vue?vue&type=template&id=0d1c7068&scoped=true"
import script from "./UiPropJsonSchema.vue?vue&type=script&lang=js"
export * from "./UiPropJsonSchema.vue?vue&type=script&lang=js"

import "./UiPropJsonSchema.vue?vue&type=style&index=0&id=0d1c7068&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1c7068"]])

export default __exports__